const KEY = 'search_custom_items';

/**
 * Simple async wrapper around localStorage to act like a datastore.
 * Can be replaced later with real server/API calls.
 */
export async function getItems() {
    try {
        const raw = localStorage.getItem(KEY);
        return raw ? JSON.parse(raw) : [];
    } catch (err) {
        return [];
    }
}

export async function saveItems(items) {
    try {
        localStorage.setItem(KEY, JSON.stringify(items || []));
        return items || [];
    } catch (err) {
        return items || [];
    }
}

export async function addItem(item) {
    const items = await getItems();
    items.unshift(item);
    await saveItems(items);
    return items;
}

export async function removeItem(index) {
    const items = await getItems();
    if (index >= 0 && index < items.length) {
        items.splice(index, 1);
        await saveItems(items);
    }
    return items;
}

export async function clearItems() {
    await saveItems([]);
    return [];
}